"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCE_FILE = void 0;
exports.SOURCE_FILE = 'main.json';
